import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canListStatuses, canManageStatuses } from "./permissions";
import { ticketStatusesRoutes } from "./routes";

export const ticketStatusesRoute = [
  {
    path: ticketStatusesRoutes.list,
    lazy: async () => {
      const { TicketStatusListPage } = await import("./pages/TicketStatusListPage");

      return {
        element: (
          <RequireAuth permission={canListStatuses}>
            <TicketStatusListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: ticketStatusesRoutes.create,
    lazy: async () => {
      const { CreateTicketStatusPage } = await import("./pages/CreateTicketStatusPage");

      return {
        element: (
          <RequireAuth permission={canManageStatuses}>
            <CreateTicketStatusPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: ticketStatusesRoutes.edit,
    lazy: async () => {
      const { EditTicketStatusPage } = await import("./pages/EditTicketStatusPage");

      return {
        element: (
          <RequireAuth permission={canManageStatuses}>
            <EditTicketStatusPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
